<template>
  <section class="container-main">
    <Header :open-menu-modal="openMenuModal" />
    <div class="container-inner">
      <div class="banner">
        <div class="banner-title">
          <h3 class="fade-in-text do-hyeon-regular" :class="{ visible: isVisible }">
            About AXIS
          </h3>
        </div>

      </div>
      <div class="container nav-container">
        <nav>
          <router-link to="/about" @click="setCurrentNav('Greeting')" :class="{ active: isActive('Greeting') }">인삿말</router-link>
          /
          <router-link to="/about?nav=service" @click="setCurrentNav('Service')" :class="{ active: isActive('Service') }">예배안내 & 오시는길</router-link>
        </nav>
      </div>

      <Greeting v-if="currentNav === 'Greeting'" :pastor-image-scale="pastorImageScale" :handle-intersect="handleIntersect" />
      <Service v-if="currentNav === 'Service'" />
    </div>

    <Footer/>

    <MenuModal v-if="menuModalView" :close-menu-modal="closeMenuModal" />
  </section>
</template>
<script>
import Header from "@/components/core/Header.vue";
import Footer from "@/components/core/Footer.vue";
import Greeting from "@/views/about/components/Greeting.vue";
import Service from "@/views/about/components/Service.vue";
import MenuModal from "@/views/modal/MenuModal.vue";

export default {
  name: "AboutUs",
  components: {MenuModal, Service, Greeting, Footer, Header},
  data() {
    return {
      init: false,
      isVisible: false,
      pastorImageScale: 1,
      currentNav: 'Greeting',
      menuModalView : false
    }
  },
  created() {
    this.init = true;
  },
  mounted() {
    // 컴포넌트가 마운트된 후에 애니메이션을 트리거
    this.showText();

  },
  methods: {
    isActive(nav) {
      return this.currentNav === nav;
    },
    setCurrentNav(nav) {
      this.currentNav = nav;
    },
    handleIntersect(entries) {

      entries.forEach((entry) => {
        // intro 이미지
        if (entry.target.id === 'messageImage' && entry.isIntersecting) {
          // this.pastorImageScale = 1.1; // 배너 이미지 확대

          // 0.5초 후에 확대 애니메이션 시작
          setTimeout(() => {
            this.pastorImageScale = 1.04; // 이미지 확대
          }, 500); // 이동 애니메이션 후 확대 애니메이션 시작 (0.5초 후)
        }
      });
    },
    showText() {
      setTimeout(() => {
        this.isVisible = true;
      }, 100)
    },

    openMenuModal() {
      this.menuModalView = true;
    },

    closeMenuModal() {
      this.menuModalView = false;
    },
  }
}
</script>


<style scoped lang="scss">
.container-main {

  .container-inner {

    .banner {

      display: flex;
      justify-content: center; /* 수평 가운데 정렬 */
      align-items: center; /* 수직 가운데 정렬 */

      position: relative;
      width: 100%;
      height: 520px;

      overflow: hidden;

      background-repeat: no-repeat;
      background-size: 2560px;
      background-position: center center;
      background-image: url("../../assets/resized/20240901_151215.jpg");
      background-attachment: fixed;
      background-position-y: -670px;
      background-color: rgba(0, 0, 0, 0.5);
      background-blend-mode: color;

      .banner-title {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 9;
        text-align: center;
        color: #fff;
        width: 1280px;
        box-sizing: border-box;
        margin: 0 auto;
        line-height: 1.4;
        padding-top: 86px;
        flex-direction: column;

        h3 {
          font-weight: 700;
          font-size: 36px;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -8px; /* 밑줄과 텍스트 사이의 여백 추가 */
            height: 3px; /* 밑줄 두께 */
            background-color: #fff; /* 밑줄 색상 */
            width: 100%; /* 호버 시 밑줄의 너비가 100%로 확장 */
          }
        }

        p {
          margin-top: 20px;
          font-weight: 200;
        }

      }

    }

    .nav-container {

      nav {
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px;
        border-bottom: 1px solid #eaeaea;

        a {
          box-sizing: border-box;
          display: inline-block;
          padding: 10px 15px;
          border-radius: 100px;
          font-size: 16px;
          color: #888;
          font-weight: 400;

          &.active {
            color: #333;
            font-weight: 700;
          }
        }
      }

      .nav-wrapper {

        max-width: 1280px;
        width: fit-content;
        margin: 0 auto;
        text-align: center;
        box-sizing: border-box;
        padding: 20px;

        .nav-item {
          float: left;
          box-sizing: border-box;
          padding: 5px;

          a {
            box-sizing: border-box;
            display: inline-block;
            padding: 10px 15px;
            border-radius: 100px;
            font-size: 14px;
            color: #555;
            font-weight: 400;

            &.active {
              background-color: #00c5e3;
              color: #fff;
              font-weight: 700;
              border: 1px solid #00c5e3;
            }
          }

        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {

}

@media screen and (max-width: 768px) {

  .container-main .container-inner .banner .banner-title h3 {
    font-size: 30px;
  }

}
</style>